/**
 * Setting to control international buying nudges
 */
export const INTERNATIONAL_BUYING_NUDGES = 'INTERNATIONAL_BUYING_NUDGES';
